export const Routes = {
  auth: { login: '/Users/authenticate' },
  product: {
    products: '/products',
    add: '/add-product',
    update: '/update-product',
    delete: '/delete-product',
  },
  cart: {
    addToCart: '/add-to-cart',
    cartList: '/cart-items',
  },
};
